module.exports = __webpack_public_path__ + "static/img/product6.ccd9d782.png";